export function lockBodyScroll() {
    document.body.classList.add('no-scroll');
}

export function unlockBodyScroll() {
    document.body.classList.remove('no-scroll');
}
